import React, { useState } from 'react';

import { FaArrowRight,FaArrowLeft } from "react-icons/fa6";

import ServerImage from './ServerImage';

const ImageGallery = ({ 
  images = [], 
  className = '', 
  showArrows = true, 
  showDots = false,
  autoPlay = false,
  autoPlayInterval = 3000,
  fallback = '/studio/photo1.png'
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Handle single image or empty array
  if (!images || images.length === 0) {
    return (
      <div className={className}>
        <ServerImage
          src=""
          alt="No image available"
          fallback={fallback}
          className="w-full h-full object-cover object-center rounded-none"
          style={{ borderRadius: '0px' }}
        />
      </div>
    );
  }

  // Single image - no navigation needed
  if (images.length === 1) {
    const image = images[0];
    return (
      <div className={className}>
        <ServerImage
          src={typeof image === 'string' ? image : image.url}
          alt={typeof image === 'string' ? 'Studio image' : (image.alt || 'Studio image')}
          fallback={fallback}
          className="w-full h-full object-cover object-center rounded-none"
          style={{ borderRadius: '0px' }}
        />
      </div>
    );
  }

  // Multiple images - show gallery with navigation
  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const goToImage = (index) => {
    setCurrentIndex(index);
  };

  const currentImage = images[currentIndex];

  return (
    <div className={`relative group ${className}`}>
      {/* Main Image */}
      <ServerImage
        src={typeof currentImage === 'string' ? currentImage : currentImage.url}
        alt={typeof currentImage === 'string' ? 'Studio image' : (currentImage.alt || 'Studio image')}
        fallback={fallback}
        className="w-full h-full object-cover object-center transition-transform duration-300 rounded-none"
        style={{ borderRadius: '0px' }}
      />

      {/* Navigation Arrows */}
      {showArrows && images.length > 1 && (
        <>
          <button
            onClick={prevImage}
            className="absolute left-4 bottom-2 md:top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10"
            aria-label="Previous image"
          >
            <FaArrowLeft className="text-gray-700" />
          </button>
          
          <button
            onClick={nextImage}
            className="absolute right-4  bottom-2 md:top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10"
            aria-label="Next image"
          >
            <FaArrowRight className="text-gray-700" />
          </button>
        </>
      )}

      {/* Dot Indicators */}
      {showDots && images.length > 1 && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-10">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => goToImage(index)}
              className={`w-2 h-2 rounded-full transition-colors ${
                index === currentIndex 
                  ? 'bg-white' 
                  : 'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Go to image ${index + 1}`}
            />
          ))}
        </div>
      )}

      {/* Image Counter
      {images.length > 1 && (
        <div className="absolute top-4 right-4 bg-black/50 text-white px-2 py-1 rounded text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          {currentIndex + 1} / {images.length}
        </div>
      )} */}
    </div>
  );
};

export default ImageGallery;